import contentService from "../../../../../mylibrary/services/contentService";
import _ from 'lodash';
export const TYPECODE = {
    TEST: 'test',
    NOTES: 'studyNotes',
    FORMULA: 'formula',
    VIDEO: 'video',
    AUDIO: 'audio',
}

export const handleAddContent = ({ contents, treeData, setTreeData, conceptPhaseData, bonusContent, bonusCriteria,isChapterLevel}: any, handleFilterSelectedQuestion: Function, showMessage: any) => {
    const { id = '' } = conceptPhaseData;
    const contentConceptId = getConceptIdOfContent(contents, id);
    const isConceptIdAndContentIdIsSame = isSameConceptId(id, contentConceptId);
    if (isConceptIdAndContentIdIsSame) {
        if (bonusContent) {
            addBonusContent({ contents, treeData, setTreeData, conceptPhaseData, bonusCriteria,isChapterLevel });
        }
        else {
            const { phases = [] } = treeData;
            let cloneTree = JSON.parse(JSON.stringify(treeData));
            let clonePhases = JSON.parse(JSON.stringify(phases));
            const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
            let courseId = clonePhases[phaseIndex]['weeks'][weekIndex]
            ['subjects'][subjectIndex]['chapters'][chapterIndex]
            ['concepts'][conceptIndex].courseSyllabusIds[0].courseId;
            const [newContent,showErrorToast] = setContent(contents, courseId,isChapterLevel);
            if(isChapterLevel){
                const chapterContent=_.get(clonePhases,`[${phaseIndex}]['weeks'][${weekIndex}]['subjects'][${subjectIndex}]['chapters'][${chapterIndex}]['content']`,[]);
                clonePhases[phaseIndex]['weeks'][weekIndex]
                ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'] = [
                        ...chapterContent, ...newContent]     
            }else{ 
                clonePhases[phaseIndex]['weeks'][weekIndex]
                ['subjects'][subjectIndex]['chapters'][chapterIndex]
                ['concepts'][conceptIndex]['content'] = [
                        ...clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]
                        ['concepts'][conceptIndex]['content'],
                        ...newContent
                    ]
            }    
            cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) }
            setTreeData({
                treeData: cloneTree
            });
           if(showErrorToast){
            if(isChapterLevel){ 
                showMessage('Concept tests cannot be added on the chapter level', 'error');
               }else{
                showMessage('Chapter tests cannot be added at the concept level','error'); 
               }
           } 
        }
        handleFilterSelectedQuestion(contents)
        return true;
    } else {
        showMessage('Content is not from provided given concept id', 'error');
        return false;
    }
}


export const handleContentSelect = (content: any, contentLength: number, handleSetState: Function) => {
    const firstSelectedQuestion = content;
    if (content.length > 0 || contentLength) {
        handleSetState({
            selectedQuestionCount: contentLength
        })
    } else {
        handleSetState({
            selectedQuestionCount: 0
        })
    }
    handleSetState({ tempQuestions: content });
}

export const handleContentSelectAll = (content: any) => {

}

const getContentType = (type: string) => {
    switch (type) {
        case 'note':
            return TYPECODE.NOTES;
        case 'videos':
            return TYPECODE.VIDEO;
        case 'formulas':
            return TYPECODE.FORMULA;
        case 'testpapers':
            return TYPECODE.TEST;
        case 'studyNotes':
            return TYPECODE.NOTES;
        case 'audios':
            return TYPECODE.AUDIO;
    }
}

const setContent = (contents: any,courseId: string,isChapterLevel?:boolean) => {
    let contentData: any = [];
    let contentObject: any = {}
    let showErrorToast=false;
    contents.forEach((content: any) => {
        if (content.contentTypeCode === 'testpapers') {
            if((isChapterLevel && content.contentSubTypeCode=='concept')||(!isChapterLevel&&content.contentSubTypeCode=='chap')){
                 if(!showErrorToast){
                   showErrorToast=true;  
                 }
            }
            else{
                contentObject = {
                id: content.content_Id || content.id,
                contentId: content.contentId,
                type: getContentType(content.contentTypeCode || content.type),
                title: content.title,
                description: "",
                isBonus: false,
                testDetails: {
                    testId: content.content_Id || content.id,
                    scheduleID: "",
                    name: content.title,
                    courseId: _.get(content,"courseId[0]",courseId),
                    syllabus: "Concept will be covered",
                    "startDate": null,
                    "endDate": null,
                    "revisionTime": 0,
                    "type": content.contentSubTypeCode || (content.testDetails && content.testDetails.type),
                    "duration": content.duration || 180
                }
            }
       
       
       
          } 
       } else {
            contentObject = {
                id: content.content_Id,
                contentId: content.contentId,
                type: getContentType(content.contentSubTypeCode),
                title: content.title,
                description: "",
                isBonus: false,
            }
        }
       if(!_.isEmpty(contentObject)){ 
        contentData.push(contentObject);
       }
        
    });
    return [contentData,showErrorToast];
}

const getExcludedIds = (data:any) => {
let ids: any = [];
  data && data.length && data.forEach((ele: any)=> {
    ids.push((ele.id));
  });
  return ids;
}

export const handleDeleteContent = (
    { treeData, setTreeData, contentItem, conceptPhaseData, preFilters }: any,
     setPreFilters:Function) => {
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = treeData;
    const clonePhases = JSON.parse(JSON.stringify(phases));
    const getAllContent = getAllContentWithIndex(phases);
    // getAllContent && getAllContent.length && getAllContent.forEach((element: any) => {
    //     const { id, indexes } = element;
    let allCloneData = {};
    const deleteData = getAllContent.get(contentItem.id)
    if(deleteData && deleteData.length){
        // if (id === contentItem.id) {
            deleteData.forEach((index:any)=> {
                const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = index;                                                        
                const phaseKey = `${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`;
                
                clonePhases[phaseIndex]['weeks'][weekIndex]
                    ['subjects'][subjectIndex]['chapters'][chapterIndex]
                    ['concepts'][conceptIndex]['content'] =
                        clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]
                        ['concepts'][conceptIndex]['content'].filter((ele: any) => ele.id !== contentItem.id);
                    const updatePhase = removeIsBulkAdded(clonePhases, phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex);
                    cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(updatePhase)) };
                    const getIds = getExcludedIds(clonePhases[phaseIndex]['weeks'][weekIndex]
                    ['subjects'][subjectIndex]['chapters'][chapterIndex]
                    ['concepts'][conceptIndex]['content']);
                     if(preFilters[phaseKey]){
                        
                        let clonePreFilter = {
                            ...preFilters[phaseKey],
                            excludedIds: [...getIds]
                        }
                        allCloneData = {
                            ...allCloneData,
                            [phaseKey]: JSON.parse(JSON.stringify(clonePreFilter ))
                        }
                    }
                    //  } else{
                    //      let clonePreFilter = {
                    //         excludedIds: [...getIds]
                    //      }
                    //      setPreFilters(phaseKey,clonePreFilter);
                    //  }    
            });
            }
        // }
        // removeIsBulkAdded(clonePhases,phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex);
    // })
    setPreFilters(allCloneData);
    setTreeData({
        treeData: cloneTree
    })
}

const addBonusContent = ({ contents, treeData, setTreeData, conceptPhaseData, bonusCriteria,isChapterLevel }: any) => {
    const { phases = [] } = treeData;
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    let clonePhases = JSON.parse(JSON.stringify(phases));
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    let courseId = clonePhases[phaseIndex]['weeks'][weekIndex]
            ['subjects'][subjectIndex]['chapters'][chapterIndex]
            ['concepts'][conceptIndex].courseSyllabusIds[0].courseId;
    const newContent = setBonusContent(contents, bonusCriteria, courseId);
        if(isChapterLevel){
                clonePhases[phaseIndex]['weeks'][weekIndex]
                ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'] = [
                        ...clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'],
                        ...newContent
                    ]     
           }else{
                clonePhases[phaseIndex]['weeks'][weekIndex]
                ['subjects'][subjectIndex]['chapters'][chapterIndex]
                ['concepts'][conceptIndex]['content'] = [
                        ...clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]
                        ['concepts'][conceptIndex]['content'],
                        ...newContent
                    ]
            }       
    cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) }
    setTreeData({
        treeData: cloneTree
    });
}

const setBonusContent = (contents: any, bonusCriteria: any, courseId: string) => {
    let contentData: any = [];
    let contentObject: any = {}
    contents.forEach((content: any) => {
        if (content.contentTypeCode === 'testpapers') {
            contentObject = {
                id: content.content_Id,
                type: getContentType(content.contentTypeCode),
                title: content.title,
                description: "",
                bonusCriteria,
                contentId: content.contentId,
                isBonus: true,
                testDetails: {
                    testId: content.content_Id,
                    scheduleID: "",
                    name: content.title,
                    courseId: courseId,
                    syllabus: "Concept will be covered",
                    "startDate": null,
                    "endDate": null,
                    "revisionTime": 0,
                    "type": content.contentSubTypeCode,
                    "duration": content.duration || 180
                }
            }
        } else {
            contentObject = {
                id: content.content_Id,
                type: getContentType(content.contentSubTypeCode),
                title: content.title,
                description: "",
                bonusCriteria,
                isBonus: true,
                contentId: content.contentId,
            }
        }
        contentData.push(contentObject);
    });
    return contentData;
}

const getAllContentWithIndex = (phases: any) => {
    let allContents: any = [];
    let allContentMap = new Map();
    phases.forEach((phase: any, phaseIndex: number) => {
        const { weeks = [] } = phase;
        weeks.forEach((week: any, weekIndex: number) => {
            const { subjects = [] } = week;
            subjects.forEach((subject: any, subjectIndex: number) => {
                const { chapters = [] } = subject;
                chapters.forEach((chapter: any, chapterIndex: number) => {
                    const { concepts = [], content = [] } = chapter;
                    content.forEach((ele: any) => {
                        allContents.push({
                            id: ele.id, indexes: {
                                phaseIndex,
                                weekIndex,
                                subjectIndex,
                                chapterIndex
                            }
                        });
                    })
                    concepts.forEach((concept: any, conceptIndex: number) => {
                        const { content = [] } = concept;
                        content.forEach((ele: any) => {
                            allContents.push({
                                id: ele.id, indexes: {
                                    phaseIndex,
                                    weekIndex,
                                    subjectIndex,
                                    chapterIndex,
                                    conceptIndex,
                                }
                            });
                        })
                    })
                })
            })
        });
    });
    allContents.forEach((element: any)=>{
      const filterIds = allContents.filter((ele: any)=> ele.id === element.id)
      if(filterIds && filterIds.length){
          let indexArray:any = [];
         filterIds.forEach((data: any)=>{
            indexArray.push(data.indexes) 
         });
         allContentMap.set(filterIds[0].id, indexArray);
      }
    });
    return allContentMap;
}
export const handleDeleteContentFromChapter = ({ treeData, setTreeData, contentItem, conceptPhaseData }: any) => {
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = treeData;
    const clonePhases = JSON.parse(JSON.stringify(phases));
    const getAllContent = getAllContentWithIndex(phases);
    const deleteData = getAllContent.get(contentItem.id)
    if(deleteData && deleteData.length){
            deleteData.forEach((index: any)=> {
                const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = index;
                clonePhases[phaseIndex]['weeks'][weekIndex]
                ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'] =
                    clonePhases[phaseIndex]['weeks'][weekIndex]
                    ['subjects'][subjectIndex]['chapters'][chapterIndex]
                    ['content'].filter((ele: any) => ele.id !== contentItem.id);
                const updatePhase = removeIsBulkAdded(clonePhases, phaseIndex, weekIndex, subjectIndex, chapterIndex);
                cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(updatePhase)) };
            })
    }
    setTreeData({
        treeData: cloneTree
    })
}
const getConceptIdOfContent = (contents: any, contentConceptId: string) => {
    let conceptIdOfContent = '';
    contents && contents.forEach((content: any) => {
        if (content && content.subjects && content.subjects.length) {
            const { subjects = [] } = content;
            subjects.forEach((subject: any) => {
                if (subject && subject.subSubjects && subject.subSubjects.length) {
                    const { subSubjects = [] } = subject;
                    subSubjects.length && subSubjects.forEach((subSubject: any) => {
                        const { chapters = [] } = subSubject;
                        chapters.forEach((chapter: any) => {
                            if (chapter && chapter.concepts && chapter.concepts.length) {
                                const { concepts = [] } = chapter;
                                concepts.forEach((concept: any) => {
                                    if (concept && concept.conceptId && Object.keys(concept.conceptId).length) {
                                        const { conceptId: { _id = '' } = {} } = concept;
                                        if (contentConceptId === _id) {
                                            conceptIdOfContent = _id;
                                        }
                                    }
                                });
                            }
                        });
                    })
                }
            });
        }
    });
    return conceptIdOfContent;
}

const isSameConceptId = (conceptId: string, contentConceptId: string) => {
    return conceptId === contentConceptId ? true : false
}

const removeIsBulkAdded = (
    phases: any, phaseIndex: number,
    weekIndex: number, subjectIndex: number,
    chapterIndex: number, conceptIndex?: number
) => {
    const removedDataFromConcept = phases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'][chapterIndex]['concepts'].filter((ele: any) => ele.content && ele.content.length);
    const removeDataFromChapter = phases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'][chapterIndex]['content'].length;
    console.log({ removedDataFromConcept, removeDataFromChapter }, ':;::::test::::');
    if (!removedDataFromConcept.length && !removeDataFromChapter) {
        phases[phaseIndex]['weeks'][weekIndex]
        ['subjects'][subjectIndex]['chapters'][chapterIndex].isBulkDataAdded = false;
    }
    const checkAllChapterContent = phases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'].filter((ele: any) => ele && ele.content && ele.content.length);
    if (!checkAllChapterContent.length) {
        phases[phaseIndex]['weeks'][weekIndex].isBulkDataAdded = false;
    }
    const checkAllWeeks = phases[phaseIndex]['weeks'].filter((ele: any) => ele && ele.isBulkDataAdded)
    if (!checkAllWeeks.length) {
        phases[phaseIndex].isBulkDataAdded = false;
    }
    return phases;
}